import { Directive, forwardRef, Input } from '@angular/core';
import {
  NG_VALIDATORS
} from '@angular/forms';
import type { Provider, Type } from '@angular/core';
import type {
  AbstractControl,
  ValidationErrors,
  Validator
} from '@angular/forms';

export const NON_ZERO_VALIDATOR: Provider = {
  provide: NG_VALIDATORS,
  useExisting: forwardRef((): Type<NonZeroValidator> => NonZeroValidator),
  multi: true
};

/**
 * Non Zero Validator Directive
 *
 * Validates that a number input field cannot be 0
 *
 * @example
 * <input type="number" nonZero/>
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[nonZero][formControlName],[nonZero][formControl],[nonZero][ngModel]',
  providers: [NON_ZERO_VALIDATOR]
})
export class NonZeroValidator implements Validator {
  private _nonZero: boolean | undefined;
  private onChange?: () => void;

  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input()
  get nonZero(): boolean | string {
    return this._nonZero;
  }

  set nonZero(value: boolean | string) {
    this._nonZero = value != null && value !== false && `${value}` !== 'false';
    if (this.onChange !== undefined) {
      this.onChange();
    }
  }

  /**
   * Static method to allow this validator function to be accessed by the reactive forms
   *
   * @param control
   * @returns
   */
  static nonZero(control: AbstractControl): ValidationErrors | null {
    return parseFloat(control.value) === 0 ? { nonZero: true } : null;
  }

  validate(c: AbstractControl): ValidationErrors | null {
    return this._nonZero !== undefined && this._nonZero ? NonZeroValidator.nonZero(c) : null;
  }

  registerOnValidatorChange(fn: () => void): void {
    this.onChange = fn;
  }
}
